import VideoPlayer from './video-player';
import './video-player.scss';

export default VideoPlayer;
